export const INCREASE_SUPPLIES = 'INCREASE_SUPPLIES';
export const DECREASE_SUPPLIES = 'DECREASE_SUPPLIES';
export const INCREASE_CASTLES = 'INCREASE_CASTLES';
export const DECREASE_CASTLES = 'DECREASE_CASTLES';
export const INCREASE_IRONTHRONE = 'INCREASE_IRONTHRONE';
export const DECREASE_IRONTHRONE = 'DECREASE_IRONTHRONE';
export const INCREASE_FIEFDOMS = 'INCREASE_FIEFDOMS';
export const DECREASE_FIEFDOMS = 'DECREASE_FIEFDOMS';
export const INCREASE_KINGSCOURT = 'INCREASE_KINGSCOURT';
export const DECREASE_KINGSCOURT = 'DECREASE_KINGSCOURT';
